module.exports = __webpack_public_path__ + "static/media/corporate-services-img49.0d53aed1.jpg";